import { DiscoveryIcon } from "../Discoveries";

/**
 * Presentational halves of the runner's post-question phases:
 *   UnlockCelebration — Figma 9452:5353 / 9453:6268 ("You've unlocked …")
 *   ArchitectureReady — Figma 9453:5934 (foundation complete)
 * All data arrives via props; the state machine lives in the runner.
 */

/** "Now part of your system" copy per legacy category (mirrors
 * DomainCompletionView's DOMAIN_COPY so both celebrations read the same). */
export const SYSTEM_COPY = {
  Identity: "They reflect the surface patterns of how you operate.",
  Cognition: "They shape how you process information.",
  Resolution: "They shape how you respond under pressure.",
  Motivation: "They shape what drives and sustains you.",
  Judgment: "They reflect how you weigh choices, commit, and act.",
};

const ElementTile = ({ element }) => (
  <div className="run-element">
    <span className="run-element__thumb">
      {element.url ? (
        <img src={element.url} alt={element.name || ""} />
      ) : (
        <span className="run-element__symbol">
          {element.symbol || (element.name || "?").slice(0, 2)}
        </span>
      )}
    </span>
    {element.name && <span className="run-element__name">{element.name}</span>}
  </div>
);

export const UnlockCelebration = ({
  icon,
  title,
  subtitle,
  systemBody,
  elements,
  progressReady,
  primaryLabel,
  onPrimary,
  onBack,
}) => (
  <div className="run-celebrate">
    <button
      type="button"
      className="journey-header__back run-celebrate__close"
      onClick={onBack}
      aria-label="Back to Discoveries"
    >
      ✕
    </button>

    <span className="run-celebrate__orb">
      <DiscoveryIcon icon={icon} title={title} />
    </span>
    <p className="run-celebrate__eyebrow">You've unlocked</p>
    <h1 className="run-celebrate__title">{title}</h1>
    {subtitle && <p className="run-celebrate__subtitle">{subtitle}</p>}

    <div className="run-elements-card">
      <p className="run-elements-card__title">These are your elements</p>
      <div className="run-elements-card__row">
        {(elements && elements.length > 0
          ? elements.slice(0, 3)
          : [null, null, null]
        ).map((element, index) =>
          element ? (
            <ElementTile element={element} key={element.name || index} />
          ) : (
            <div className="run-element" key={index}>
              <span className="run-element__thumb" />
            </div>
          )
        )}
      </div>
      <p className="run-elements-card__more">More to explore</p>
    </div>

    <p className="run-celebrate__system-title">Now part of your system</p>
    {systemBody && <p className="run-celebrate__system-body">{systemBody}</p>}

    {!progressReady ? (
      <button type="button" className="journey-button" disabled>
        One moment…
      </button>
    ) : primaryLabel ? (
      <button type="button" className="journey-button" onClick={onPrimary}>
        {primaryLabel}
      </button>
    ) : null}
    <button type="button" className="journey-link run-celebrate__back" onClick={onBack}>
      Back to Discoveries
    </button>
  </div>
);

export const ArchitectureReady = ({ finalDiscovery, onOpen }) => (
  <div className="run-celebrate run-ready">
    <span className="run-ready__orb" aria-hidden="true" />
    <p className="run-celebrate__eyebrow">Congratulations!</p>
    <h1 className="run-celebrate__title">
      Your Personal Behavioral Architecture is Ready
    </h1>
    <p className="run-celebrate__subtitle">
      You've completed all 4 Discoveries. Your insights have unlocked your full
      behavioral architecture.
    </p>
    <p className="run-ready__emerged">
      Your final domain has emerged from everything Aris has learned about you.
    </p>

    <div className="journey-card run-ready__card">
      <span className="journey-list__tile run-ready__tile">
        <DiscoveryIcon
          icon={finalDiscovery?.icon}
          title={finalDiscovery?.title}
        />
      </span>
      <div className="journey-list__text run-ready__text">
        <p className="journey-list__label">
          {finalDiscovery?.title || "How You Make Decisions"}
        </p>
        <p className="journey-list__sub">Your final domain</p>
        <p className="journey-list__sub">Now part of your complete system</p>
      </div>
    </div>

    <button type="button" className="journey-button" onClick={onOpen}>
      Opening your Personal Behavioral Architecture
    </button>
  </div>
);
